var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDumbell = function SvgDumbell(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2305 28.1801H37.3905",
    className: "highlight",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3503 32.23H22.3604",
    className: "highlight",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31999 32.23H6.92999C5.81999 32.23 4.91999 31.34 4.90999 30.23C4.89999 29.11 5.80999 28.19 6.92999 28.19H9.33999",
    className: "highlight",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.07 28.18H52.46C53.57 28.18 54.47 29.07 54.48 30.18C54.49 31.3 53.58 32.22 52.46 32.22H50.05",
    className: "highlight",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0704 24.11C22.0704 22.34 20.6304 20.9 18.8604 20.9C17.0904 20.9 15.6504 22.34 15.6504 24.11V36.32C15.6504 38.09 17.0904 39.53 18.8604 39.53C20.6304 39.53 22.0704 38.09 22.0704 36.32V24.11Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.07 23.23H12.75C11.32 23.23 10.16 24.39 10.16 25.82V34.61C10.16 36.04 11.32 37.2 12.75 37.2H13.07C14.5 37.2 15.66 36.04 15.66 34.61V25.82C15.66 24.39 14.5 23.23 13.07 23.23Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4004 36.31C37.4004 38.08 38.8404 39.52 40.6104 39.52C42.3804 39.52 43.8204 38.08 43.8204 36.31V24.11C43.8204 22.34 42.3904 20.9 40.6104 20.9C38.8304 20.9 37.4004 22.34 37.4004 24.11V36.32V36.31Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.39 37.19H46.72C48.15 37.19 49.31 36.03 49.31 34.6V25.82C49.31 24.39 48.15 23.23 46.72 23.23H46.39C44.96 23.23 43.8 24.39 43.8 25.82V34.61C43.8 36.04 44.96 37.2 46.39 37.2V37.19Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDumbell);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/svg-icons/dumbell.svg";